import {NgClass} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {DonneesOnglet} from './DonneesOnglet';
import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {FonteIconeComponent} from '../fonte-icone/fonte-icone.component';

//Composant onglet
@Component (
{
  selector: 'val-onglet',
  imports: 
  [
    NgClass,
    SimpleLibelleComponent,
    FonteIconeComponent
  ],
  templateUrl: './onglet.component.html',
  styleUrl: './onglet.component.scss'
})
export class OngletComponent implements OnInit 
{
  //Création
  constructor ()
  {
    this.selection = new EventEmitter<DonneesOnglet>;
    this.rafraichissement = new EventEmitter<DonneesOnglet>;
    this.couleurCss = "undefined";
    this.iconeCouleurCss = "";
  }

  //Onglet
  @Input ()
  public onglet!: DonneesOnglet;

  //Evénement sélection
  @Output ()
  public selection: EventEmitter<DonneesOnglet>;

  //Evénement rafraichissement
  @Output ()
  public rafraichissement: EventEmitter<DonneesOnglet>;

  //Couleur CSS
  public couleurCss: string;

  //Couleur de l’icone
  public iconeCouleurCss: string;

  //Compteur de lignes à afficher à la suite du libellé
  //  Retourne
  //    null si l’onglet ne porte aucun compteur — rien n’est alors affiché,
  //    "x" si le chargement est complet, "(>x)" tant qu’une page suivante peut exister
  public get compteurLignes () : string | null
  {
    if (this.onglet.nombreLignesChargees === null || this.onglet.nombreLignesChargees === undefined)
      return null;

    return this.onglet.chargementComplet ? `${this.onglet.nombreLignesChargees}`
                                         : `(>${this.onglet.nombreLignesChargees})`;
  }

  //Initialisation
  public ngOnInit () : void 
  {
    this.couleurCss = this.onglet.couleur ? "#" + (this.onglet.couleur & 0xFFFFFF).toString (16).padStart (6, "0") : "undefined";

    if (this.onglet.iconeCouleur)
      this.iconeCouleurCss = this.onglet.iconeCouleur ? "#" + (this.onglet.iconeCouleur & 0xFFFFFF).toString (16).padStart (6, "0") : "undefined";
  }

  //Envoie l’événement sélection
  public Selection () : void 
  {
    this.selection.emit (this.onglet);
  }

  //Envoie l’événement rafraichissement
  public Rafraichissement () : void 
  {
    this.rafraichissement.emit (this.onglet);
  }
}
